import styled, { css } from 'styled-components'

// TODO: transfer to max
const sideBarWidth = '300px'

export const Row = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: table-row;
  }
`

export const Body = styled.div`
  vertical-align: top;
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: table-cell;
    padding-top: ${({ theme }) => theme.space.lg};
    width: ${`calc(100% - ${sideBarWidth})`};
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    width: ${({ theme }) => `calc(100% - ${theme.layout.xxxl})`};
  }
`

// TODO: transfer to max
export const RightSidebar = styled.div`
  display: table-cell;
  vertical-align: top;
  padding: ${({ theme }) => `${theme.space.sm} ${theme.space.lg} 0 ${theme.space.lg}`};
  background: ${({ theme }) => theme.colors.brandPrimaryContrast};
  position: absolute;
  top: ${({ theme }) => theme.layout.xl};
  right: ${({ theme }) => `-${theme.space.xxs}`};
  width: ${({ theme }) => `calc(100% - ${theme.space.xs})`};
  max-width: ${({ theme }) => theme.layout.xxxl};
  // transfer values to max
  box-shadow: 0 0 4px 3px rgba(0, 0, 0, 0.1);
  border-radius: ${({ theme }) => theme.radius.md};
  &.main {
    display: none;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: ${sideBarWidth};
    padding: ${({ theme }) => theme.space.lg};
    right: 0;
    top: auto;
    position: relative;
    box-shadow: none;
    border-radius: 0;
    &.main {
      display: table-cell;
    }
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    width: ${({ theme }) => theme.layout.xxxl};
  }
  z-index: 1;
`

export const ToggleDrawer = styled.div`
  .enter-right-enter {
    opacity: 0;
    transform: translate(350px, 0);
  }
  .enter-right-enter-active {
    opacity: 1;
    transform: translateX(0);
    transition-property: transform, opacity;
    transition-duration: 300ms;
    transition-timing-function: cubic-bezier(0.175, 0.665, 0.32, 1), linear;
  }
  .enter-right-exit {
    opacity: 1;
    transform: translateX(0);
  }
  .enter-right-exit-active {
    opacity: 0;
    transform: translate(350px, 0);
    transition-property: transform, opacity;
    transition-duration: 300ms;
    transition-timing-function: cubic-bezier(0.175, 0.665, 0.32, 1), linear;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: none;
  }

  ${({ showToggleOnMobile }) =>
    showToggleOnMobile &&
    css`
      display: block;

      @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
        display: none;
      }
    `}
`

// TODO: transfer to max
export const ToggleDrawerButton = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.layout.xl};
  right: 0;
  z-index: 1000;
  // review spacing used in mocks to finalize spacing in max-theme-portal
  padding: 20px 10px;
  background: ${({ theme }) => theme.colors.brandPrimaryContrast};
  box-shadow: 0 0 4px 3px rgba(0, 0, 0, 0.1);
  border-radius: 3px 0 0 3px;
`

export const CloseToggleButton = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.space.sm};
  right: ${({ theme }) => theme.space.lg};
  z-index: 1;
`

export const Wrapper = styled.div<{ sidebarXsOrder?: any; isAdmin?: boolean }>`
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: ${({ theme }) => `calc(100% + ${theme.space.xl})`};
    display: table;
    margin-top: ${({ theme }) => `-${theme.space.lg}`};
    min-height: calc(100vh - ${({ isAdmin }) => (isAdmin ? '166px' : '130px')});
  }

  ${({ sidebarXsOrder }) =>
    sidebarXsOrder &&
    css`
      ${RightSidebar} {
        padding: ${({ theme }) => `${theme.space.md} ${theme.space.sm}`};
        position: relative;
        top: unset;
        left: unset;
        right: unset;
        width: calc(100% + ${({ theme }) => theme.space.lg});
        max-width: calc(100% + ${({ theme }) => theme.space.lg});
        margin-left: -${({ theme }) => theme.space.sm};
        box-shadow: none;
        border-radius: 0;
        &.main {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
          margin-left: -${({ theme }) => theme.space.sm};
        }

        @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
          width: calc(100% + 56px);
          max-width: calc(100% + 56px);
          margin-left: -${({ theme }) => theme.space.lg};
          border: 0;
        }

        @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
          width: ${sideBarWidth};
          padding: ${({ theme }) => theme.space.lg};
          right: 0;
          top: auto;
          &.main {
            display: table-cell;
          }
        }

        @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
          width: ${({ theme }) => theme.layout.xxxl};
        }
      }

      ${ToggleDrawerButton} {
        padding: 0;
      }
    `};
`
